<template>
<v-card
    class="mx-auto"
    max-width="100%"
  >
  <v-card
    class="mx-auto"
    max-width="100%"
  >

        <v-row >
           <v-col cols="12" md="1">
          <v-img
            src="http://restrito.esaudeluanda.com:7000/config/nulo-foto.jpg"
            alt="Snow"
            width="90"
          ></v-img>
        </v-col>
        <v-col cols="12" md="7">
          <h1>Relatório de {{this.relatorio_Dados.especificacaoRelatorio.descricao}}</h1>
          Período:{{this.relatorio_Dados.data_in}} à {{this.relatorio_Dados.data_fim}}
          <br>Gerado em: {{this.date}}
          <v-progress-circular v-if="isLoading" class="v-progress-circular" style="color:blue"
      :size="50"
      :width="10"
      indeterminate
      color="blue"
    ></v-progress-circular>
        </v-col>
         <v-col cols="12" md="2">
           <img @click="imprimirRelatorio()" style="margin-left:30px"  width="50px"  src="../../assets/pdf_exibir.png">
           <img @click="excelPrint()" style="margin-left:30px"  width="50px"  src="../../assets/download.png">
        </v-col>
      </v-row>
      <v-card>
              <template>
                  <!--Ínicio Cliente -->
                   <v-simple-table class="tabela" fixed-header v-if="isCliente">
                  <template v-slot:default>
                    <thead>
                      <td class="linhas">Ord.</td>
    <td class="linhas">Nome</td>
    <td class="linhas">Data de nascimento</td>
    <td class="linhas">Sexo</td>
    <td class="linhas">Telefone</td>
    <td class="linhas"> Email</td>
    <td class="linhas"> Saldo</td>
    <td class="linhas">Data de cadastro</td>
                    </thead>

                    <tbody>
<tr v-for="(item,i) in clientesORFornecedores" :key="i">
  <td  class="tabela">{{ i+1 }}</td>
    <td class="linhas">{{item.nome}}</td>
    <td class="linhas">{{item.data_nascimento}}</td>
    <td class="linhas">{{item.sexo}}</td>
    <td class="linhas">{{item.telefone}}</td>
    <td class="linhas">{{item.email}}</td>
    <td class="linhas">{{item.saldo}}</td>
    <td class="linhas">{{item.data_cadastro}}</td>
</tr>

                    </tbody>
                  </template>
                </v-simple-table>
                 <!--Fim Cliente -->

                   <!--Ínicio Fornecedor -->
                   <v-simple-table class="tabela" fixed-header v-if="isFornecedor">
                  <template v-slot:default>
                    <thead>
                     <td class="linhas">Ord.</td>
    <td class="linhas">Nome</td>
    <td class="linhas">NIF</td>
    <td class="linhas">Tipo Fornecedor</td>
    <td class="linhas">Telefone1</td>
    <td class="linhas">Telefone2</td>
    <td class="linhas"> Email</td>
    <td class="linhas"> Data de Cadastro</td>
    <td class="linhas"> Observacao</td>
                    </thead>

                    <tbody>
<tr v-for="(item,i) in clientesORFornecedores" :key="i">
 <td  class="tabela">{{ i+1 }}</td>
    <td class="linhas">{{item.nome}}</td>
    <td class="linhas">{{item.nif}}</td>
    <td class="linhas">{{item.tipoFornecedor}}</td>
    <td class="linhas">{{item.telefone1}}</td>
     <td class="linhas">{{item.telefone2}}</td>
    <td class="linhas">{{item.email}}</td>
    <td class="linhas">{{item.data_cadastro}}</td>
    <td class="linhas">{{item.observacao}}</td>
</tr>

                    </tbody>
                  </template>
                </v-simple-table>
                 <!--Fim Fornecedor -->

                  <!--Ínicio Produto -->
                <v-simple-table class="tabela" fixed-header v-if="isProduto">
                  <template v-slot:default>
                    <thead>
                      <td class="linhas">Ord.</td>
    <td class="linhas">Cód. Produto</td>
    <td class="linhas">Nome</td>
    <td class="linhas">Cód. Barra</td>
    <td class="linhas">Grupo do produto</td>
    <td class="linhas">Valor de venda</td>
    <td class="linhas">Stock</td>
    <td class="linhas">Fornecedor</td>
                    </thead>

                    <tbody>
<tr v-for="(item,i) in relatorioProdutos" :key="i">
  <td  class="tabela">{{ i+1 }}</td>
    <td class="linhas">{{item.pkProduto}}</td>
    <td class="linhas">{{item.produtodescricao}}</td>
    <td class="linhas">{{item.codigoBarra}}</td>
    <td class="linhas">{{item.familiaProduto}}</td>
    <td class="linhas">{{formatMoney(item.precoSemIva)}}</td>
    <td class="linhas">{{(item.stock)}}</td>
    <td class="linhas"></td>
</tr>

                    </tbody>
                  </template>
                </v-simple-table>
                <!--Fim Produto -->
                 <template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
         Exportar para Excel - Deseja Continuar
        </v-card-title>

        <v-card-text>
            Clique para Continuar
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn style="background-color:red;color:white" @click="dialog=false">Cancelar</v-btn>
           <export-excel
                :data   = "dadosBody"
              :fields="head"
              >
          <v-btn @click="dialog=false">Continuar</v-btn>
        </export-excel>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  </template>
              </template>
            </v-card>
  </v-card>
  </v-card>
</template>

<script>
import axios from '../../plugins/axios'
import Vue from 'vue'
import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)
const ls = require('local-storage')
export default {
  data () {
    return {
      head: '',
      dadosBody: [],
      dialog: false,
      html: ``,
      isLoading: false,
      descricaoRelatorio: '',
      date: '',
      periodo: '',
      relatorioProdutos: [],
      relatorio_Dados: {},
      clientesORFornecedores: [],
      formatter: 0,
      pdf: [],
      isProduto: false,
      isCliente: false,
      isFornecedor: false,
      json_fields: {
        'Complete name': 'name',
        'City': 'city',
        'Telephone': 'phone.mobile',
        'Telephone 2': {
          field: 'phone.landline',
          callback: (value) => {
            return `Landline Phone - ${value}`
          }
        }
      },
      json_data: [
        {
          'name': 'Tony Peña',
          'city': 'New York',
          'country': 'United States',
          'birthdate': '1978-03-15',
          'phone': {
            'mobile': '1-541-754-3010',
            'landline': '(541) 754-3010'
          }
        },
        {
          'name': 'Thessaloniki',
          'city': 'Athens',
          'country': 'Greece',
          'birthdate': '1987-11-23',
          'phone': {
            'mobile': '+1 855 275 5071',
            'landline': '(2741) 2621-244'
          }
        }
      ],
      json_meta: [
        [
          {
            'key': 'charset',
            'value': 'utf-8'
          }
        ]
      ]
    }
  },
  created () {
    this.date = this.correntDate()
    this.relatorio_Dados = ls.get('relatoriosVendas')
    this.choiceRelatorio()
  },
  methods: {
    excelPrint () {
      this.dialog = true
    },
    imprimirRelatorio () {
      this.isLoading = true
      setTimeout(() => {
        this.$router.push('/imprimir_pdf')
      }, 30000)
    },
    choiceRelatorio () {
      if (this.relatorio_Dados.especificacaoRelatorio.pkrelatorio === 1) { this.isCliente = true; this.clienteFornecedor_Relatorio() } else
      if (this.relatorio_Dados.especificacaoRelatorio.pkrelatorio === 2) { this.isFornecedor = true; this.clienteFornecedor_Relatorio() } else
      if (this.relatorio_Dados.especificacaoRelatorio.pkrelatorio === 3) { this.isProduto = true; this.relatorioProdutos_() }
    },
    async relatorioProdutos_ () {
      try {
        this.relatorioProdutos = await axios
          .post('/produto_Relatorio', this.relatorio_Dados.produto_Relatorio)
          .then(res => res.data)
        this.isLoading2 = false
        this.comporHTML()
      } catch (error) {
        this.$store.dispatch('textMessage', { 'msg': error, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async clienteFornecedor_Relatorio () {
      try {
        this.clientesORFornecedores = await axios
          .post('/clienteFornecedor_Relatorio', this.relatorio_Dados.clienteFornecedor_Relatorio)
          .then(res => res.data)
        this.isLoading = false
        this.comporHTML()
      } catch (error) {
        this.$store.dispatch('textMessage', { 'msg': error, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async gerarPdf () {
      let html_ = { 'html': this.html, 'usuario': ls.get('nomeUsuario'), 'pkDoc': 1 }
      try {
        this.pdf = await axios
          .post('/html_pdf', html_)
          .then(res => res.data)
      } catch (error) {
        this.$store.dispatch('textMessage', { 'msg': error, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    formatMoney (value) {
      this.formatter = new Intl.NumberFormat('AOA', {
        style: 'currency',
        currency: 'AKZ'
      })
      var a = this.formatter.format(value)
      return a
    },
    comporHTML () {
      let header = ` `
      let dadosCadastro = ``
      let i = 0
      if (this.isCliente) {
        header = ` <td class="linhas">Ord.</td>
    <td class="linhas">Nome</td>
    <td class="linhas">Data de nascimento</td>
    <td class="linhas">Sexo</td>
    <td class="linhas">Telefone</td>
    <td class="linhas"> Email</td>
    <td class="linhas"> Saldo</td>
    <td class="linhas">Data de cadastro</td>`
        this.dadosBody = this.clientesORFornecedores
        this.clientesORFornecedores.forEach(element => {
          i++
          dadosCadastro += `<tr>
    <td class="linhas">` + i + `</td>
    <td class="linhas">` + element.nome + `</td>
    <td class="linhas">` + element.data_nascimento + `</td>
    <td class="linhas">` + element.sexo + `</td>
    <td class="linhas">` + element.telefone + `</td>
    <td class="linhas">` + element.email + `</td>
    <td class="linhas">` + element.saldo + `</td>
    <td class="linhas">` + element.data_cadastro + `</td>
</tr>`
        })
      } else
      if (this.isFornecedor) {
        header = ` <td class="linhas">Ord.</td>
    <td class="linhas">Nome</td>
    <td class="linhas">NIF</td>
    <td class="linhas">Tipo Fornecedor</td>
    <td class="linhas">Telefone1</td>
    <td class="linhas">Telefone2</td>
    <td class="linhas"> Email</td>
    <td class="linhas"> Data de Cadastro</td>
    <td class="linhas"> Observacao</td>`
        this.dadosBody = this.clientesORFornecedores
        this.clientesORFornecedores.forEach(element => {
          i++
          dadosCadastro += `<tr>
    <td class="linhas">` + i + `</td>
    <td class="linhas">` + element.nome + `</td>
    <td class="linhas">` + element.nif + `</td>
    <td class="linhas">` + element.tipoFornecedor + `</td>
    <td class="linhas">` + element.telefone1 + `</td>
    <td class="linhas">` + element.telefone2 + `</td>
    <td class="linhas">` + element.email + `</td>
    <td class="linhas">` + element.observacao + `</td>
    <td class="linhas">` + element.data_cadastro + `</td>
</tr>`
        })
      } else
      if (this.isProduto) {
        header = `  <td class="linhas">Ord.</td>
    <td class="linhas">Cód. Produto</td>
    <td class="linhas">Nome</td>
    <td class="linhas">Cód. Barra</td>
    <td class="linhas">Grupo do produto</td>
    <td class="linhas">Valor de venda</td>
    <td class="linhas">Stock</td>
    <td class="linhas">Fornecedor</td>`
        this.head = { 'cod. prod': 'pkProduto', 'Nome': 'produtodescricao', 'Cod. Barra': 'codigoBarra', 'Grupo do produto': 'familiaProduto', 'Valor de venda': 'precoSemIva', 'Stock': 'stock', 'Fornecedor': 'Null' }
        this.dadosBody = this.relatorioProdutos
        this.relatorioProdutos.forEach(element => {
          i++
          dadosCadastro += `<tr>
    <td class="linhas">` + i + `</td>
    <td class="linhas">` + element.pkProduto + `</td>
    <td class="linhas">` + element.produtodescricao + `</td>
    <td class="linhas">` + element.codigoBarra + `</td>
    <td class="linhas">` + element.familiaProduto + `</td>
    <td class="linhas">` + this.formatMoney(element.precoSemIva) + `</td>
    <td class="linhas">` + element.stock + `</td>
    <td class="linhas"></td>
   
</tr>`
        })
      }

      this.html = `

<style>
.linhas {
  border: 1px solid black;
  border-collapse: collapse;
}

</style>

<html>
    <head>
        <title>Recibos</title>
    </head>
<body>
    <table style="border:0px solid black;margin-left:0px;margin-right:auto;">
    <tr>
        <td>
            <div class="column">
   <span style="padding-top:1px!important">  <img src="http://restrito.esaudeluanda.com:7000/config/IMS/icon/logo.png" alt="Snow" style="width:100%; max-width:150px;" /></span>
  </div>
        </td>
         <td> 
       <h1>Relatório de ` + this.relatorio_Dados.especificacaoRelatorio.descricao + `</h1>
<br><span>Período: ` + this.relatorio_Dados.data_in + `à` + this.relatorio_Dados.data_fim + `</span>
<br><span>Gerado em: ` + this.date + ` </span>
        </td>
         
    </tr>
    
       </table>


<br>
<table width=100% class="linhas">
<tr class="linhas">
   ` + header + `
</tr>
` + dadosCadastro + `

</table>
   
</body>
</html>`
      this.gerarPdf()
    },
    correntDate () {
      let data = new Date()
      var month = []
      month[0] = 'Janeiro'
      month[1] = 'Fevereiro'
      month[2] = 'Maço'
      month[3] = 'Abril'
      month[4] = 'Maio'
      month[5] = 'Junho'
      month[6] = 'Julho'
      month[7] = 'Agosto'
      month[8] = 'Setembro'
      month[9] = 'Outubro'
      month[10] = 'Novembro'
      month[11] = 'Dezembro'
      return data.getDate().toString() + ' de ' + month[(data.getMonth() + 1)] + ' de ' + data.getFullYear().toString()
    }
  }
}
</script>
<style scoped>
.linhas {
  border: 1px solid black;

}
</style>
